// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ZW3vT","title":"styles_title__2pj8F"};